import React from "react";

import Card from "react-credit-cards";
import Thanks  from "./components/Thanks";
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "./utils";
import styles from "./styles.css";

import "react-credit-cards/es/styles-compiled.css";

export default class App extends React.Component {
  state = {
    number: "",
    name: "",
    expiry: "",
    cvc: "",
    issuer: "",
    focused: "",
  
    email:"",
    phone:"",

    done:false
  };


  handleInputFocus = ({ target }) => {
     

    this.setState({
      focused: target.name
    });
  };

  handleInputChange = ({ target }) => {
    switch(target.name){
      case 'number':
        target.value = formatCreditCardNumber(target.value);
      break;
      case 'expiry':
        target.value = formatExpirationDate(target.value);
        break;
        case 'cvc':
          target.value = formatCVC(target.value);
          break;
         
    }
    // if (target.name === "number") {
    //   target.value = formatCreditCardNumber(target.value);
    // } else if (target.name === "expiry") {
    //   target.value = formatExpirationDate(target.value);
    // } else if (target.name === "cvc") {
    //   target.value = formatCVC(target.value);
    // }

    this.setState({ [target.name]: target.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    const {dugoly_uid,amount, business_name, logo_id, client_id}=this.props.match.params;
    const { name, number, expiry, cvc, focused } = this.state;
   

const data={dugoly_uid,amount, business_name, logo_id, client_id, name, number, expiry, cvc, focused}
   
fetch("https://dugoly.com/api/save_credit", {
      method: "POST", 
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(respon => respon.text())
    .then(res => {
      console.log("Request complete! response:", res);
      const path=document.referrer+"/Credit-report"
      console.log("path:", path);

      const Credit_report_data={dugoly_uid,business_name,client_id,transaction_ID:res}
      fetch(path, {
      method: "POST", 
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(Credit_report_data)
    })
    });
    this.form.reset();
    this.setState({
      done: true
    });
};

  render() {
   const {dugoly_uid,amount, business_name, logo_id, client_id}=this.props.match.params;
    
    const { name, number, expiry, cvc, focused } = this.state;

    return (
      <div   >
        <div className="logo-container"> 
        <img src={`https://www.easydone.online/uploads/${dugoly_uid}/${logo_id}`}  className="logo" /><br/>
      <h1>  {business_name} </h1>
        {/* </div> */}
        {/* <div className="App-payment"> */}
           
          <Card
            number={number.length<4?number:number.slice(0, 4)+"********"+number.slice(14)}
            name={name}
            expiry={expiry}
            cvc={cvc}
            focused={focused}
           
          />
         
          {this.state.done?<Thanks business_name={business_name} />:<form ref={c => (this.form = c)} onSubmit={this.handleSubmit}>
            <div className="form-group">
              
              <input
                type="tel"
                name="number"
                className="form-control"
                placeholder="Card Number"
                pattern="[\d| ]{16,22}"
                required
                onChange={this.handleInputChange}
                onFocus={this.handleInputFocus}
              />
             
            </div>
            <div className="form-group">
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Name"
                required
                onChange={this.handleInputChange}
                onFocus={this.handleInputFocus}
              />
            </div>
            <div className="row">
              <div className="col-6">
                <input
                  type="tel"
                  name="expiry"
                  className="form-control"
                  placeholder="Valid Thru"
                  pattern="\d\d/\d\d"
                  required
                  onChange={this.handleInputChange}
                  onFocus={this.handleInputFocus}
                />
              </div>
              <div className="col-6">
                <input
                  type="tel"
                  name="cvc"
                  className="form-control"
                  placeholder="CVC"
                  pattern="\d{3,4}"
                  required
                  onChange={this.handleInputChange}
                  onFocus={this.handleInputFocus}
                />
              </div>
            </div>
            <br />
            {/* <div className="form-group">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="email"
                required
                onChange={this.handleInputChange}
               
              />
              </div>
              <div className="form-group">
                <input
                id="phoneNumber" 
                placeholder="Phone Number" 
                maxlength="16"
                type="tel"
                name="phone"
                className="form-control"
                required
                onChange={this.handleInputChange}
                />
            </div>  */}
            <input
            type="checkbox"
            required
             /> I have read the terms of use and I approve them
             <br />

            {/* <input
            type="checkbox"
            required
             />Credit collection is done by the referring party and under his responsibility */}
            {/* <input type="hidden" name="issuer" value={issuer} /> */}
            <div className="form-actions">
              <button className="btn btn-primary btn-block">PAY</button>
            </div>
          </form>}
         
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/App.js